<div class="employers">
</div>
<div class="title-container-1">
  <div class="title-container-2">
    <div class="search-text">404</div>
  </div>
</div>
<div class="container-1">
  <div #containerRef class="container-2 scroll-fade">
    <div class="left apple-card">
      <h1 class="title">Pagina niet gevonden</h1>
      <div class="information">
        <div>Sorry, we hebben de pagina niet kunnen vinden. Misschien is de pagina verplaatst of bestaat hij niet meer.</div>
      </div>
      <div>
        <a class="apple-cta apple-cta--blue" routerLink="/">
          <span>Naar de homepage</span>
          <icon name="navigate_next" aria-hidden="true"></icon>
        </a>
      </div>
    </div>
  </div>
</div>
